import { EMPTY_OBJ, EMPTY_ARR } from '@constants';

import useResourceList from './useResourceList';
import useQuery from './useQuery';
import mutationFactory from './mutationFactory';

import api from '..';

export const useMinisitesList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'minisites', api: api.minisites }, queryVariables, queryConfig);

  return {
    minisites: queryResult.resolvedData,
    latestMinisites: queryResult.latestData,
    ...queryResult,
  };
};

export const useMinisite = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['minisite', { id }], api.minisites.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    minisite: queryResult.data || EMPTY_OBJ,
    ...queryResult,
  };
};

export const useMinisitesByIds = (ids, queryConfig = {}) => {
  const queryResult = useQuery(['minisites', { ids }], api.minisites.getByIds, {
    ...queryConfig,
    enabled: ids?.length > 0,
  });

  return {
    minisites: queryResult.data || EMPTY_ARR,
    ...queryResult,
  };
};

const mutation = mutationFactory({ invalidate: 'minisites' });

export const useDeleteMinisite = mutation(api.minisites.remove);
export const useCreateMinisite = mutation(api.minisites.create);
export const useSaveMinisite = mutation(api.minisites.save);
export const useUpdateMinisite = mutation(api.minisites.update);
